export default __webpack_public_path__ + "5e8326f55aaef540e9979021370278ea.ogg";